import { sidebarLinkData } from '@/lib/main';
import { cn } from '@/lib/utils/global';
import { FC } from 'react';
import { Link } from 'react-router-dom';
interface LinkInfoProps {
  hoveredIndex: number | null;
  setHoveredIndex: (index: number | null) => void;
}
const LinkInfo: FC<LinkInfoProps> = ({ hoveredIndex, setHoveredIndex }) => {
  const permissionRoutes = JSON.parse(
    localStorage.getItem('permissionRoutes') || '[]'
  );
  permissionRoutes.push('/nms', '/report');
  const cleanPath = (path: string) => path.replace(/\//g, '');

  return (
    <>
      <Link
        to="/"
        className="bg-[#1141A5] h-[75px] flex items-center">
        <img
          width="auto"
          className="max-h-[25px] lg:max-h-[40px]"
          src="/assets/images/sidebar/name.png"
          loading="lazy"
        />
      </Link>

      {sidebarLinkData
        .filter((linkItem) =>
          permissionRoutes.some(
            (route: string) => cleanPath(route) === cleanPath(linkItem.to)
          )
        ) // Filter based on permissionRoutes
        .map((linkItem, index) => (
          <Link
            key={`${linkItem.to}_${index}`}
            to={linkItem.to}
            onClick={(e) => {
              if (linkItem.title === 'NMS') {
                e.preventDefault();
                e.stopPropagation();
                window.open('https://wnms.gomatimvvnl.in/nms/16789/dashboard');
              } else if (linkItem.title === 'REPORT') {
                e.preventDefault();
                e.stopPropagation();
                window.open(
                  'https://grafana.gomatimvvnl.in/dashboards/f/aedbaj1dqxzi8c/'
                );
              }
            }}
            className={`text-ellipsis overflow-hidden rounded-r-lg group-hover:mr-3 h-[55px] flex items-center sidebar-item-${index}`}
            onMouseEnter={() => setHoveredIndex(index)}
            onMouseLeave={() => setHoveredIndex(null)}>
            <span
              className={cn(
                'text-xs lg:secondary-title font-bold text-white',
                hoveredIndex === index && 'text-[#00c4b4]'
              )}>
              {linkItem.title}
            </span>
          </Link>
        ))}
    </>
  );
};

export default LinkInfo;
